<template>
    <resources-base-table
        :inputs="inputs"
        :headers="headers"
        :items="carreras"
        :defaultItem="defaultItem"
        :editedItem="editedItem"
        :modelService="carrerasService"
        @updated="afterEdit"
    >
        <template v-slot:actions="{ item }">
            <router-link :to="{ name: 'carrerasSede', params: { id: item.id } }">
                <v-icon small>carreras sede</v-icon>
            </router-link>
        </template>

        <template v-slot:form="{ localEditedItem }">
            <v-text-field v-model="localEditedItem['carrera']" :label="'Nombre'"></v-text-field>
            <v-select v-model="localEditedItem.areaId" :items="areas" item-text="area" item-value="id"></v-select>
        </template>
    </resources-base-table>
</template>

<script>
import { CarrerasService } from "../../../services/carreras-api.service"

export default {
    data: () => ({
        carrerasService: CarrerasService,
        inputs: [
            { sortable: false, text: "Nombre", value: "carrera" },
            { sortable: false, text: "Area", value: "area" }
        ],
        headers: [
            {
                sortable: false,
                text: "ID",
                value: "id"
            },
            {
                sortable: false,
                text: "Carrera",
                value: "carrera"
            },
            { text: "Acciones", value: "action", sortable: false }
        ],
        defaultItem: {
            carrera: "",
            areaId: ""
        },
        editedItem: {
            carrera: "",
            areaId: ""
        }
    }),
    methods: {
        getDefaultArea() {
            return (this.editedItem.areaId = this.areas.find(area => area.id == this.$router.currentRoute.params.id))
        },
        afterEdit(item) {
            if (item.areaId != this.$router.currentRoute.params.id) {
                this.carreras.splice(this.carreras.indexOf(item), 1)
            }
        }
    },
    created() {
        this.getDefaultArea()
    },
    props: ["carreras", "areas"]
}
</script>
